import { Entry } from '../Entry'

export function Entry20240403() {
  return (
    <Entry title="Apr 03 2024 - v3.5.16">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15707/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
